import React from 'react'
// hocs
import withKPI from 'components/Modals/PlanItems/KPI/withKPI'
// components
import { Tab } from '@mui/material'
import { Tabs, Scrollbar } from 'components/UI'
import { LoaderWithOverlay } from 'components/UI/Loader'
// view components
import DetailsSection from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection/index'
// views
import { SubHeader } from 'components/Modals/PlanItems/styles'
// types
import { LogEntityTypes } from 'types/graphql'
// context
import { KPIContext } from 'context/index'

const KPIDetails: React.FunctionComponent<any> = ({ entity }) => {
  const [tab, setTab] = React.useState(0)

  const { isLoading } = React.useContext<any>(KPIContext)

  const handleSetTab = (_, value) => setTab(value)

  return (
    <>
      <LoaderWithOverlay isLoading={isLoading} />
      {!isLoading && entity && (
        <>
          <SubHeader>
            <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
              <Tab label='Details' />
            </Tabs>
          </SubHeader>

          <Scrollbar>
            {tab === 0 && <DetailsSection entity={{ ...entity, entityType: LogEntityTypes.Kpi }} />}
          </Scrollbar>
        </>
      )}
    </>
  )
}

export default withKPI(KPIDetails)
